import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";

export default function PayAppHome() {
  const { ApiBaseUrl } = useContext(MyContext);
  const [categories, setCategories] = useState([]);
  const [partners, setPartners] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const load = () => {
    axios.get(`${ApiBaseUrl}/pv/customer/categories`).then((r) => setCategories(r.data.categories || []));
    const params = new URLSearchParams();
    if (categoryId) params.set("category_id", categoryId);
    if (q) params.set("q", q);
    axios.get(`${ApiBaseUrl}/pv/customer/partners?${params}`).then((r) => setPartners(r.data.partners || []));
  };

  useEffect(() => { load(); }, [categoryId, ApiBaseUrl]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex flex-wrap justify-between items-end gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-bold text-rm-ink">Pay via App</h1>
          <p className="text-gray-600">Instant partner-funded discounts when you pay in the app.</p>
        </div>
        <Link to="/pay-app/history" className="bg-rm-primary text-white px-4 py-2 rounded">My payments</Link>
      </div>
      <div className="flex flex-wrap gap-3 mb-6">
        <select className="border rounded px-3 py-2" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
          <option value="">All categories</option>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <input className="border rounded px-3 py-2 flex-1 min-w-[200px]" placeholder="Search partners" value={q} onChange={(e) => setQ(e.target.value)} />
        <button className="bg-rm-primary text-white px-4 py-2 rounded" onClick={load}>Search</button>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {partners.map((p) => (
          <div key={p.id} className="border rounded-xl p-4 bg-white cursor-pointer hover:shadow-md" onClick={() => navigate(`/pay-app/partner/${p.id}`)}>
            <p className="text-xs uppercase text-rm-primary">{p.category_name || p.partner_type}</p>
            <h3 className="text-xl font-semibold mt-1">{p.display_name}</h3>
            <p className="text-sm text-gray-500 mt-2 line-clamp-2">{p.address || "Verified partner"}</p>
            <span className="inline-block mt-3 text-rm-deep font-medium">View offers →</span>
          </div>
        ))}
      </div>
      {!partners.length && <p className="text-center text-gray-500 py-10">No partners found.</p>}
    </div>
  );
}
